// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'ellipsis',
  standalone: true,
})
export class EllipsisPipe implements PipeTransform {
  transform(val: string, args: number): string {
    if (val == null) {
      return '';
    }

    if (args == null) {
      return val;
    }

    if (val.length > args) {
      return val.substring(0, args) + '...';
    }

    return val;
  }
}
